export const faqs = [
  {
    question: 'Sous quel format est-ce que je reçois le pack ?',
    answer:
      'Le Jazz Master et les 5 bonus sont des fichiers PDF haute qualité, prêts à imprimer ou à utiliser sur tablette.',
  },
  {
    question: 'Comment vais-je recevoir le matériel ?',
    answer:
      "Immédiatement après votre achat, vous recevez un e-mail avec vos liens de téléchargement. Vous y avez accès à vie.",
  },
  {
    question: 'Est-ce adapté à mes élèves débutants ?',
    answer:
      'Oui. Le système Jazz Master est organisé par niveaux : débutant, intermédiaire et avancé. Vous savez toujours par où commencer.',
  },
  {
    question: 'Puis-je imprimer les fiches pour tous mes élèves ?',
    answer:
      'Absolument. La licence professeur vous permet d’imprimer autant de copies que nécessaire pour vos propres élèves.',
  },
  {
    question: 'Et si le pack ne me convient pas ?',
    answer:
      "Vous êtes couvert par notre garantie satisfait ou remboursé de 10 jours. Un simple e-mail suffit, sans aucune question.",
  },
];
